import PopupHeader from "@builder/components/app/Popup/PopupHeader";
import "./style.scss";
import { GlobalBlockTypes } from "@common/build/types";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import OliverText from "@builder/components/general/OliverText";
import Button from "@builder/components/general/Button";
import { useRef, useState } from "react";
import { closePopup } from "@builder/store/slices/popupSlice";
import { useOutsideClick } from "@builder/hooks/useOutsideClick";
import TextInput from "@builder/components/general/TextInput";
import { attachGlobalBlock } from "@builder/store/slices/BuilderSlice/builderSlice";
import Loading from "@builder/components/app/Loading";
import { useCreateGlobalBlockMutation, useGetGlobalBlocksQuery } from "@builder/store/slices/BuildsApiSlice/buildsApiSlice";
import { skipToken } from "@reduxjs/toolkit/query";

export const globalBlockHeader: { [key: string]: { title: string; src: string } } = {
    [GlobalBlockTypes.GB_PRINT]: { title: "Print blocks", src: "./print-button-icon.svg" }
    // [GlobalBlockTypes.GB_CFD]: "Customer facing display",
    // [GlobalBlockTypes.GB_GRID_CARD]: "Grid card",
    // [GlobalBlockTypes.GB_CI]: "Card item"
};

const GlobalBlocks = () => {
    const dispatch = useAppDispatch();
    const gbState = useAppSelector(state => state.popup.globalBlocks);
    const [inputVisible, setInputVisible] = useState<boolean>(false);
    const [newGBName, setNewGBName] = useState<string>("");
    const inputRef = useRef<HTMLDivElement>(null);
    // const companyId = useAppSelector(state => state.storeData?.company?._id);
    const companyId = useAppSelector(state => state.builder.build.companyId);
    const { data: globalBlocks, isLoading: isLoadingGlobalBlocks } = useGetGlobalBlocksQuery(
        companyId && gbState ? { companyId, gbType: gbState } : skipToken
    );
    const [createGlobalBlock, { isLoading: isLoadingCreateGlobalBlock }] = useCreateGlobalBlockMutation();

    useOutsideClick(inputRef, () => {
        setInputVisible(false);
        setNewGBName("");
    });

    const handleNewBuild = async () => {
        if (gbState && newGBName.length > 0 && companyId) {
            const newBuild = await createGlobalBlock({ companyId, gbType: gbState, name: newGBName });
            if (newBuild) {
                const url = new URL(window.location.href);
                window.open(`${url.protocol}//${url.hostname}${url.port ? `:${url.port}` : ""}?id=${newBuild}`, "_blank");
                dispatch(closePopup());
            }
        }
    };

    const handleOpenBuild = (sourceId?: string) => {
        if (sourceId) {
            const url = new URL(window.location.href);
            window.open(`${url.protocol}//${url.hostname}${url.port ? `:${url.port}` : ""}?id=${sourceId}`, "_blank");
        }
    };

    const handleAttachGB = (id: string, name: string) => {
        dispatch(attachGlobalBlock({ id, name }));
        dispatch(closePopup());
    };

    return (
        <div className="global-blocks-wrapper">
            <PopupHeader {...globalBlockHeader[gbState || ""]} />
            <div className="global-blocks-body">
                {isLoadingGlobalBlocks || isLoadingCreateGlobalBlock ? (
                    <div className="loading-wrapper">
                        <Loading />
                    </div>
                ) : (
                    <>
                        <div className="new-global-block">
                            <div className="img-wrapper">
                                <img src="./builder-icon.svg" alt="" />
                            </div>

                            {inputVisible ? (
                                <div className="new-gb-input-wrapper" ref={inputRef}>
                                    <TextInput placeholder={`Enter build name`} value={newGBName} callback={(value: string) => setNewGBName(value)} />
                                    <Button text="Create" buttonStyle="secondary" className="new-gb-button" onClick={handleNewBuild} />
                                </div>
                            ) : (
                                <>
                                    <div className="text-group">
                                        <OliverText weight="semi-bold" text="Blank canvas" />
                                        <OliverText size="xs" text="For people who want to take time to setup the perfect build for them" />
                                    </div>
                                    <Button
                                        text="Start from scratch"
                                        buttonStyle="secondary"
                                        className="new-gb-button"
                                        onClick={() => setInputVisible(true)}
                                    />
                                </>
                            )}
                        </div>
                        {globalBlocks?.map(gb => (
                            <div key={gb.id} className="global-block">
                                <div className="header-row">
                                    <OliverText text={gb.name} weight="semi-bold" className="header-text" />
                                    {gb.sourceId && (
                                        <button onClick={() => handleOpenBuild(gb.sourceId)}>
                                            <img src="./save-preview-icon.svg" alt="" />
                                        </button>
                                    )}
                                </div>
                                <div className="image-wrapper">
                                    <img src={gb.img || "./custom-build.svg"} alt="" />
                                </div>
                                <Button
                                    text="Use print block"
                                    buttonStyle="secondary"
                                    className="gb-button"
                                    onClick={() => handleAttachGB(gb.id, gb.name)}
                                />
                            </div>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
};

export default GlobalBlocks;
